import { a as l } from "./chunk-BaseElement-BuXbltG-.js";
import { t as h } from "./chunk-custom-element-ttkHUa8w.js";
import { n as d } from "./chunk-property-Baio2yOX.js";
import { e as p } from "./chunk-query-pk3khlGb.js";
var f = Object.defineProperty, g = Object.getOwnPropertyDescriptor, r = (i, t, o, s) => {
  for (var e = s > 1 ? void 0 : s ? g(t, o) : t, a = i.length - 1, c; a >= 0; a--)
    (c = i[a]) && (e = (s ? c(t, o, e) : c(e)) || e);
  return s && e && f(t, o, e), e;
};
let n = class extends l {
  constructor() {
    super(), this._handleToggleSpecification = this._handleToggleSpecification.bind(this);
  }
  connectedCallback() {
    super.connectedCallback(), this.formatDescription(), this.showMoreText = this.showMore.querySelector("span"), window.addEventListener("resize", () => {
      window.innerWidth <= 767 && this.initSpecsToggle();
    }), window.innerWidth <= 767 && this.initSpecsToggle();
  }
  formatDescription() {
    const i = this.querySelector("[data-description]");
    if (!i) return;
    const t = i.querySelectorAll("h2, h3");
    t && t.forEach((o) => {
      var e;
      const s = o;
      s.textContent && (s.textContent = (e = s.textContent) == null ? void 0 : e.toLowerCase());
    }), i.setAttribute("data-formatted", "");
  }
  _handleToggleSpecification() {
    var t;
    const i = this.specs.getAttribute("data-expanded") === "false";
    this.specs.classList.toggle("max-h-96"), (t = this.showMore.parentElement) == null || t.classList.toggle("absolute"), this.showMore.classList.toggle("expanded"), this.specs.setAttribute("data-expanded", i.toString());
  }
  initSpecsToggle() {
    this.initSpecsFunction || (this.initSpecsFunction = !0, this.specs.setAttribute("data-expanded", "false"), this.showMore.addEventListener(
      "click",
      this._handleToggleSpecification.bind(this)
    ));
  }
};
r([
  d({ type: Boolean, reflect: !0, attribute: "init-specs-toggle" })
], n.prototype, "initSpecsFunction", 2);
r([
  p("[data-specs]")
], n.prototype, "specs", 2);
r([
  p("[data-toggle-specs]")
], n.prototype, "showMore", 2);
n = r([
  h("specification-text")
], n);
export {
  n as SpecificationText
};
